import React from 'react';
import classNames from 'classnames';
import SectionComponent from '../Section';
import Utils from '../../../Services/Utils';

class LfaForm extends React.Component {
  render() {
    const { configuration, fieldsData, fieldsError, api, onFieldAdded, onPressedWorkOrder, previewLanguage, created_in_language } = this.props;
    const scoreType = (!Utils.isNull(configuration.scoreType) && !Utils.isNull(configuration.scoreType.value)) ?
      configuration.scoreType.value : configuration.scoreType;
    const columns = (!Utils.isNull(configuration.columns) && !Utils.isNull(configuration.columns.value)) ?
      configuration.columns.value : configuration.columns;

    return (
      <div className={ classNames('WrapperDynamicForm_Columns WrapperDynamicForm_Columns_' + columns, {
        WrapperDynamicForm_Columns_Score: scoreType > 0,
      }) } id="parentDFContent">
        { configuration.sections.order.map(sectionId => (
          <div key={ sectionId } className='WrapperDynamicSection'>
            <SectionComponent
              descriptionAsIcon={ configuration.descriptionAsIcon }
              showTriggerConditionMet={ configuration.showTriggerConditionMet }
              isCompact={ columns > 1 }
              configuration={ {...configuration.sections.items[sectionId],'previewLanguage': previewLanguage, 'created_in_language' : created_in_language} }
              data={ fieldsData.sections[sectionId] }
              errors={ fieldsError.sections[sectionId] }
              onFieldAdded={ onFieldAdded }
              onPressedWorkOrder={ onPressedWorkOrder }
              api={ api }
              scoreFormType={ scoreType }
            />
          </div>
        )) }
      </div>
    );
  }
}

export default LfaForm;